import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Edit from './Edit';

import {
  updateEvent,
  formFieldChange,
  getEventDetails,
  closeModal,
} from './actions';

const mapStateToProps = state => ({
  ...state.staff.events.edit,
  filteredChunks: state.staff.events.list.filteredChunks,
  cities: state.staff.cities,
  fields: state.staff.events.list.fields,
  role: state.account.profile.role,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getEventDetails: () =>
    dispatch(
      getEventDetails(
        ownProps.match.params.appname,
        ownProps.match.params.event,
        ownProps.match.params.memberbody,
      ),
    ),
  onSubmit: () =>
    dispatch(
      updateEvent(
        ownProps.match.params.event,
        ownProps.history,
        ownProps.match.params.appname,
        ownProps.match.params.memberbody,
      ),
    ),
  onRequestClose: role =>
    ownProps.match
      ? dispatch(
          closeModal(ownProps.match.params.appname, ownProps.history, role),
        )
      : null,
  onFieldChange: (isRequired, type, field, value, index) =>
    dispatch(formFieldChange(isRequired, type, field, value, index)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Edit),
);
